import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist'
import { extractRawText } from 'mammoth'
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url'

GlobalWorkerOptions.workerSrc = pdfWorkerUrl

async function readTxtFile(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = () => reject(new Error('Failed to read file'))
    reader.readAsText(file)
  })
}

async function readPdfFile(file: File): Promise<string> {
  const arrayBuffer = await file.arrayBuffer()
  const pdf = await getDocument({ data: arrayBuffer }).promise
  const textParts: string[] = []

  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i)
    const content = await page.getTextContent()
    const pageText = content.items
      .filter((item) => 'str' in item)
      .map((item) => (item as any).str)
      .join(' ')
    textParts.push(pageText)
  }

  return textParts.join('\n\n')
}

async function readDocxFile(file: File): Promise<string> {
  const arrayBuffer = await file.arrayBuffer()
  const result = await extractRawText({ arrayBuffer })
  return result.value
}

export async function readFileAsText(file: File): Promise<string> {
  const ext = file.name.split('.').pop()?.toLowerCase()

  switch (ext) {
    case 'txt':
      return readTxtFile(file)
    case 'pdf':
      return readPdfFile(file)
    case 'docx':
      return readDocxFile(file)
    case 'doc':
      throw new Error('Please save your .doc file as .docx or paste the text directly')
    default:
      throw new Error(`Unsupported file format: .${ext}`)
  }
}
